export const trackers = {
  customWorkflow: {
    customWorkflowInlineInput: {
      selectField: 'Select {{field}}',
      unknownInputType: 'Unknown input type: {{inputType}}',
    },
  },
  trackers: {
    about: {
      title: 'About trackers',
    },
    assets: 'Assets',
    back: 'Back',
    briefsBoardExists: 'This organization already has its briefs tracker; open it from the list.',
    briefs: 'Briefs',
    cancel: 'Cancel',
    clearSearch: 'Clear search',
    couldNotCreateTheTracker: 'Could not create the tracker',
    couldNotDeleteTheTracker: 'Could not delete the tracker',
    couldNotDuplicateTheTracker: 'Could not duplicate the tracker',
    couldNotLoadTrackers: 'Could not load your trackers',
    couldNotLoadTrackersDescription: 'Something went wrong on our side. Try again in a moment.',
    tryAgain: 'Try again',
    createAnEmptyTrackerAnd: 'Create an empty tracker and set it up yourself.',
    createTracker: 'Create tracker',
    customTracker: 'Custom tracker.',
    delete: 'Delete',
    deleteTracker: 'Delete tracker',
    deleteTrackerConfirmation:
      'Delete <name>{{trackerName}}</name> and all of its items? This can\u2019t be undone.',
    description: 'Description',
    duplicate: 'Duplicate',
    eGCampaignLaunches: 'e.g. Campaign launches',
    freeForm: 'Free form',
    fromRecordsYouAlreadyHave: 'From records you already have',
    groupedByProject: 'Grouped by project.',
    itemsYouTypeDirectlyOn: 'Items you type directly on the tracker.',
    itemType: 'Item type',
    name: 'Name',
    nameAZ: 'Name (A–Z)',
    nameZA: 'Name (Z–A)',
    newestFirst: 'Newest first',
    newTracker: 'New tracker',
    noMatchingTrackers: 'No matching trackers',
    noTrackersMatchThisFilter: 'No trackers match this filter.',
    oldestFirst: 'Oldest first',
    optional: '(optional)',
    ownershipFilter: {
      all: 'All',
      createdByMe: 'Created by me',
      label: 'Show trackers',
      sharedWithMe: 'Shared with me',
    },
    pickAReadyMadeTracker:
      'Pick a ready-made tracker — columns, views, and dashboard preconfigured.',
    projects: 'Projects',
    searchTrackers: 'Search trackers',
    searchTrackersLabel: 'Search trackers',
    showAllTrackers: 'Show all trackers',
    sortTrackers: 'Sort trackers',
    startBlank: 'Start blank',
    startEmpty: 'Start empty',
    startFromATemplate: 'Start from a template',
    templateGalleryDialog: {
      back: 'Back',
      creatingYourTracker: 'Creating your tracker…',
      default: 'Default',
      defaultTemplates: 'Default templates',
      loading: 'Loading…',
      noSavedTemplatesYetSave:
        'No saved templates yet — save a tracker as a template to reuse it here.',
      noTemplates: 'No templates.',
      savedTemplates: 'Saved templates',
      savedTemplatesCouldNotBeLoaded:
        'Saved templates could not be loaded. The default templates above still work.',
      searchTemplates: 'Search templates',
      searchTemplatesLabel: 'Search templates',
      startFromATemplate: 'Start from a template',
    },
    thisTracker: 'this tracker',
    trackerActionsFor: '{{name}} actions',
    trackerBoard: {
      aboutThisTracker: 'About this tracker',
      allBriefsAcrossYourProjects: 'All briefs across your projects.',
      briefType: 'Brief type',
      configureGroups: 'Configure groups',
      couldNotRenameTheTracker: 'Could not rename the tracker',
      customTracker: 'Custom tracker.',
      loadingTracker: 'Loading tracker…',
      loadingTrackers: 'Loading trackers…',
      project: 'Project',
      thisTrackerMayHaveBeen: 'This tracker may have been deleted, or the link is out of date.',
      trackerName: 'Tracker name',
      trackerNotFound: 'Tracker not found',
      trackersUpgrading: 'Trackers are being upgraded',
      trackersUpgradingDescription:
        'Your organization’s trackers are being upgraded. This usually takes a minute; try again shortly.',
      untitled: 'Untitled',
      untitledGroup: 'Untitled Group',
    },
    trackerCard: {
      canEdit: 'Can edit',
      canView: 'Can view',
      createdByYou: 'Created by you',
      everyoneInOrganization: 'Everyone in organization',
      onlyYou: 'Only you',
      private: 'Private',
      sharedBy: 'Shared by {{name}}',
      sharedByTeammate: 'Shared by a teammate',
      organizationDefault: 'Organization default',
      sharedWith_one: 'Shared with {{count}}',
      sharedWith_other: 'Shared with {{count}}',
    },
    trackerCopy: '{{name}} copy',
    trackerDetailsMenu: {
      cancel: 'Cancel',
      couldNotSaveTheTemplate: 'Could not save the template',
      description: 'Description',
      editDetails: 'Edit details',
      name: 'Name',
      optional: '(optional)',
      saveAsTemplate: 'Save as template',
      saveTemplate: 'Save template',
      templateSaved: 'Template saved',
      templateName: '{{name}} template',
      trackerActions: 'Tracker actions',
      whoCanReuseIt: 'Who can reuse it',
    },
    editTrackerSheet: {
      cancel: 'Cancel',
      color: 'Color',
      couldNotUpdateTheTracker: 'Could not update the tracker',
      description: 'Description',
      editTracker: 'Edit tracker',
      icon: 'Icon',
      name: 'Name',
      optional: '(optional)',
      preview: 'Preview',
      saveChanges: 'Save changes',
      untitledTracker: 'Untitled tracker',
    },
    trackerAppearance: {
      hues: {
        neutral: 'Neutral',
        blue: 'Blue',
        purple: 'Purple',
        teal: 'Teal',
        green: 'Green',
        yellow: 'Yellow',
        orange: 'Orange',
        red: 'Red',
      },
      icons: {
        lightbulb: 'Lightbulb',
        document: 'Document',
        notebook: 'Notebook',
        projectFolder: 'Project folder',
        checkmark: 'Checkmark',
        calendar: 'Calendar',
        megaphone: 'Megaphone',
        bug: 'Bug',
        kanbanBoard: 'Kanban board',
        copies: 'Copies',
        store: 'Store',
        people: 'People',
        barChart: 'Bar chart',
        rocket: 'Rocket',
        target: 'Target',
        flag: 'Flag',
        star: 'Star',
        briefcase: 'Briefcase',
        palette: 'Palette',
        checklist: 'Checklist',
        globe: 'Globe',
      },
    },
    trackersConstants: {
      manageAndTrackYourWork: 'Manage and track your work in one place',
      trackers: 'Trackers',
    },
    trackerShareButton: {
      accessLevelFor: 'Access for {{name}}: {{level}}',
      canEdit: 'Can edit',
      canView: 'Can view',
      couldNotLoadAccess: 'Could not load who has access',
      couldNotLoadAccessDescription:
        'Try again before changing who can open this tracker, so nobody is removed by mistake.',
      addPeopleFromOrganization: 'Add people from your organization',
      everyoneInTheOrganization: 'Everyone in the organization',
      generalAccess: 'General access',
      generalAccessLabel: 'Who can open this tracker',
      onlyPeopleWithAccess: 'Only people with access',
      privateAccess: 'Private',
      privateAccessHint:
        'Only the people below can open it. Organization admins can always open it.',
      publicAccess: 'Public',
      publicAccessHint: 'Anyone in your organization can find and open it.',
      peopleWithAccess: 'People with access',
      retry: 'Try again',
      save: 'Save',
      share: 'Share',
      shareTracker: 'Share tracker',
      trackerSharingUpdated: 'Tracker sharing updated.',
      unknownUser: 'Unknown user',
    },
    trackersHubEmptyState: {
      createYourFirstTracker: 'Create your first tracker',
      createdBy: 'Created by {{name}}',
      createdByTeammate: 'Created by a teammate',
      description:
        'Trackers keep briefs, projects, assets and ideas in one shared view. Pick a template below or build one from scratch.',
      startFromScratch: 'Start from scratch',
    },
    tryADifferentSearch: 'Try a different search.',
    viewOnly: {
      badge: 'View only',
    },
    whatWillThisTrackerKeep: 'What will this tracker keep track of?',
    withApprovalState: 'With approval state.',
    withStatusOwnerAndDeadline: 'With status, owner and deadline.',
  },
  trackersBoard: {
    addColumnModal: {
      aClickableButtonThatRuns: 'A clickable button that runs an automation.',
      aClickableUrl: 'A clickable URL.',
      actions: 'Actions',
      addColumn: 'Add column',
      addGroup: 'Add group',
      aDoneNotDoneToggle: 'A done / not-done toggle.',
      allColumns: 'All columns',
      approval: 'Approval',
      aSimpleDoneNotDone: 'A simple done / not-done toggle.',
      aSingleCalendarDate: 'A single calendar date.',
      nameTheTeamOnTheWork: 'Name the team or squad on the work.',
      assignOneOrMoreWorkspace: 'Assign one or more workspace members.',
      assignWorkspaceMembers: 'Assign workspace members.',
      linkDocumentsOrImages: 'Link documents or images.',
      briefs: 'Briefs',
      briefType: 'Brief type',
      button: 'Button',
      calculatedFromOtherColumns: 'Calculated from other columns.',
      calendarDate: 'Calendar date.',
      checkbox: 'Checkbox',
      chooseWhatKindOfData:
        'Choose what kind of data this column holds. You can rename it after adding.',
      colouredLabelFromAPreset: 'Coloured label from a preset list.',
      completionAsAPercentage: 'Completion as a percentage.',
      date: 'Date',
      dateRange: 'Date range',
      dates: 'Dates',
      default: 'Default',
      essentials: 'Essentials',
      files: 'Files',
      formula: 'Formula',
      link: 'Link',
      mediaAndLinks: 'Media & links',
      noColumnTypesMatch: 'No column types match your search.',
      number: 'Number',
      numbers: 'Numbers',
      numericValues: 'Numeric values.',
      people: 'People',
      peopleGroup: 'People',
      phaseBarsAcrossASchedule: 'Phase bars across a schedule.',
      plainFreeFormText: 'Plain, free-form text.',
      plainTextValuesFreeForm: 'Plain text values, free-form.',
      progress: 'Progress',
      project: 'Project',
      projectAssets: 'Project assets',
      projects: 'Projects',
      requestASignOffFrom: 'Request a sign-off from a reviewer.',
      reviewApprovalsProgressForThe:
        'Review & Approvals progress for the whole project, the same figure on every one of its briefs (read-only).',
      runsAnAutomationOnClick: 'Runs an automation on click.',
      searchColumnTypes: 'Search column types',
      searchColumnTypesLabel: 'Search column types',
      showsEachBriefSProject: "Shows each brief's project — group by it (read-only).",
      showsEachBriefSType: "Shows each brief's type (read-only).",
      startAndEndDatesWith: 'Start and end dates with a timeline.',
      startEndDatesWithA: 'Start & end dates with a progress timeline.',
      status: 'Status',
      team: 'Team',
      text: 'Text',
      timeline: 'Timeline',
    },
    automationModel: {
      actionOptions: {
        assignPeople: 'Assign people',
        checkUncheck: 'Check / uncheck',
        clearAField: 'Clear a field',
        moveToAGroup: 'Move to a group',
        setADateToToday: 'Set a date to today',
        setANumber: 'Set a number',
        setAStatus: 'Set a status',
        setText: 'Set text',
        shiftADate: 'Shift a date',
        incrementANumber: 'Add to a number',
        copyAValue: 'Copy a value',
        notifyPeople: 'Notify people',
        commentOnTheRow: 'Comment on the row',
        sendAWebhook: 'Send a webhook',
        postToSlack: 'Post to Slack',
        createARow: 'Create a row',
        duplicateTheRow: 'Duplicate the row',
        moveTheRow: 'Move the row',
        archiveTheRow: 'Archive the row',
      },
      actionSeparator: ', then ',
      aColumn: 'a column',
      aGroup: 'a group',
      anApprovalIsDecided: 'an approval is decided',
      approvalEvents: {
        approved: 'the asset is approved',
        changesRequested: 'changes are requested on the asset',
        stepCompleted: 'an approval step is completed',
      },
      anItemIsCreated: 'an item is created',
      assignPeopleToColumn: 'assign {{people}} to {{column}}',
      aValue: 'a value',
      checkColumn: 'check {{column}}',
      clearColumn: 'clear {{column}}',
      clearPeopleOnColumn: 'clear people on {{column}}',
      columnArrives: '{{column}} arrives',
      columnBecomesQuotedValue: '{{column}} becomes "{{value}}"',
      columnBecomesValue: '{{column}} becomes {{value}}',
      columnChanges: '{{column}} changes',
      columnIsChecked: '{{column}} is checked',
      columnIsClicked: '{{column}} is clicked',
      columnIsUnchecked: '{{column}} is unchecked',
      daysBeforeColumn_one: '{{count}} day before {{column}}',
      daysBeforeColumn_other: '{{count}} days before {{column}}',
      doNothingYet: 'do nothing yet',
      doSomething: 'do something',
      moveItToGroup: 'move it to {{group}}',
      setColumnToQuotedValue: 'set {{column}} to "{{value}}"',
      setColumnToToday: 'set {{column}} to today',
      setColumnToValue: 'set {{column}} to {{value}}',
      somethingChanges: 'something changes',
      triggerOptions: {
        aButtonIsClicked: 'A button is clicked',
        aCheckboxIsCheckedUnchecked: 'A checkbox is checked / unchecked',
        aDateArrives: 'A date arrives',
        aFieldValueChanges: 'A field value changes',
        anApprovalIsDecided: 'An approval is decided',
        anItemIsCreated: 'An item is created',
        aStatusChanges: 'A status changes',
        peopleChange: 'People change',
        anApprovalChanges: 'An approval changes',
        aFileIsAdded: 'A file is added',
        onASchedule: 'On a schedule',
      },
      uncheckColumn: 'uncheck {{column}}',
      whenTriggerThenActions: 'When {{trigger}}, {{actions}}.',
      weekdays: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
      },
      approvalStates: {
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
      },
      operators: {
        equals: 'Exactly',
        greaterThan: 'Greater than',
        lessThan: 'Less than',
        between: 'Between',
        contains: 'Text containing',
        isEmpty: 'Empty',
        isNotEmpty: 'Not empty',
      },
      columnBecomesGreaterThan: '{{column}} goes above {{value}}',
      columnBecomesLessThan: '{{column}} goes below {{value}}',
      columnBecomesBetween: '{{column}} comes within {{min}} to {{max}}',
      columnComesToContain: '{{column}} comes to contain "{{value}}"',
      columnIsEmptied: '{{column}} is emptied',
      columnIsFilledIn: '{{column}} is filled in',
      daysAfterColumn_one: '{{count}} day after {{column}}',
      daysAfterColumn_other: '{{count}} days after {{column}}',
      everyDayAt_one: 'it is {{time}}',
      everyDayAt_other: 'it is {{time}}',
      everyWeekdaysAt_one: 'it is {{time}} on {{days}}',
      everyWeekdaysAt_other: 'it is {{time}} on {{days}}',
      listSeparator: ', ',
      columnChangesFromTo: '{{column}} changes from {{from}} to {{to}}',
      columnChangesFrom: '{{column}} changes from {{from}}',
      columnBecomesAnythingBut: '{{column}} becomes anything but {{value}}',
      columnIsMarkedState: '{{column}} is {{state}}',
      aFileIsAddedToColumn: 'a file is added to {{column}}',
      setColumnToTodayPlus_one: 'set {{column}} to today plus {{count}} day',
      setColumnToTodayPlus_other: 'set {{column}} to today plus {{count}} days',
      assignTheEditorToColumn: 'assign whoever made the change to {{column}}',
      assignTheCreatorToColumn: 'assign whoever created the row to {{column}}',
      moveColumnEarlier_one: 'move {{column}} {{count}} day earlier',
      moveColumnEarlier_other: 'move {{column}} {{count}} days earlier',
      moveColumnLater_one: 'move {{column}} {{count}} day later',
      moveColumnLater_other: 'move {{column}} {{count}} days later',
      addToColumn: 'add {{value}} to {{column}}',
      subtractFromColumn: 'subtract {{value}} from {{column}}',
      copySourceIntoColumn: 'copy {{source}} into {{column}}',
      notifyRecipients: 'email {{recipients}}',
      commentQuotedText: 'comment “{{text}}”',
      sendAWebhookTo: 'send a webhook to {{host}}',
      postTheRowToSlack: 'post the row to Slack',
      addARow: 'add a row “{{title}}”',
      addARowToAnotherBoard: 'add a row “{{title}}” to another board',
      copyTheRow: 'copy the row',
      copyTheRowToAnotherBoard: 'copy the row to another board',
      moveTheRowToAnotherBoard: 'move the row to another board',
      archiveTheRow: 'archive the row',
      aUrl: 'a URL',
      recipients: {
        theEditor: 'whoever made the change',
        theCreator: 'whoever created the row',
        peopleInColumn: 'the people in {{column}}',
        namedPeople_one: '{{count}} person',
        namedPeople_other: '{{count}} people',
        nobodyYet: 'nobody yet',
      },
      someone: 'someone',
      valueSeparator: ' or ',
      columnIsValues: '{{column}} is {{values}}',
      columnIsNotValues: '{{column}} is not {{values}}',
      allConditionSeparator: ' and ',
      anyConditionSeparator: ' or ',
      whenTriggerIfConditionsThenActions: 'When {{trigger}}, if {{conditions}}, {{actions}}.',
      daysBeforeStartOf_one: '{{count}} day before the start of {{column}}',
      daysBeforeStartOf_other: '{{count}} days before the start of {{column}}',
      daysBeforeEndOf_one: '{{count}} day before the end of {{column}}',
      daysBeforeEndOf_other: '{{count}} days before the end of {{column}}',
      daysAfterStartOf_one: '{{count}} day after the start of {{column}}',
      daysAfterStartOf_other: '{{count}} days after the start of {{column}}',
      daysAfterEndOf_one: '{{count}} day after the end of {{column}}',
      daysAfterEndOf_other: '{{count}} days after the end of {{column}}',
      startOfColumnArrives: 'the start of {{column}} arrives',
      endOfColumnArrives: 'the end of {{column}} arrives',
      weekdaysInSentence: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
      },
      columnChangesFromToAnythingBut: '{{column}} changes from {{from}} to anything but {{value}}',
      timeInZone: '{{time}} ({{zone}})',
    },
    automationPeoplePicker: {
      anyoneOrClear: 'Anyone / clear',
      formerMember: 'Former member',
      noPeopleFound: 'No people found',
      personCount_one: '{{count}} person',
      personCount_other: '{{count}} people',
      searchPeople: 'Search people',
      searchPeopleLabel: 'Search people',
    },
    automationRuleFields: {
      addAction: 'Add action',
      anyDecision: 'Any decision',
      anyChange: 'Any change',
      anyValue: 'Any value',
      approvalDecision: 'Decision',
      approvalOptions: {
        approved: 'Approved',
        changesRequested: 'Changes requested',
        stepCompleted: 'A step is completed',
      },
      becomes: 'Becomes',
      button: 'Button',
      checked: 'Checked',
      column: 'Column',
      dateColumn: 'Date column',
      fieldToClear: 'Field to clear',
      group: 'Group',
      numberColumn: 'Number column',
      onTheDay: 'On the day',
      pickAButtonColumn: 'Pick a button column',
      pickAColumnBeforeSaving:
        'Pick a column for the trigger to watch. Without one this rule would never run. Add a column to the board first if there is nothing to choose.',
      pickACheckboxColumn: 'Pick a checkbox column',
      pickADateColumn: 'Pick a date column',
      pickAField: 'Pick a field',
      pickAPeopleColumn: 'Pick a people column',
      pickAStatusColumn: 'Pick a status column',
      pickWhatEachActionWrites:
        'Pick what each action writes. An action with nothing to write is skipped when the rule runs.',
      removeAction: 'Remove action',
      textToSet: 'Text to set',
      then: 'Then',
      trigger: 'Trigger',
      action: 'Action',
      assignTo: 'Assign to',
      direction: 'Direction',
      unchecked: 'Unchecked',
      value: 'Value',
      when: 'When',
      from: 'From',
      anythingExcept: 'Anything except',
      anythingButValue: 'Anything but {{value}}',
      fromAndTo: 'Between',
      upTo: 'Up to',
      days: 'days',
      daysBefore: 'Days before',
      daysAfter: 'Days after',
      watches: 'Watches',
      theStart: 'The start',
      theEnd: 'The end',
      eachPhaseStart: 'The start of each phase',
      eachPhaseEnd: 'The end of each phase',
      pickAnApprovalColumn: 'Pick an approval column',
      pickAFilesColumn: 'Pick a files column',
      boardColumns: 'Board columns',
      projectFields: 'Project fields',
      assetFields: 'Asset fields',
      at: 'At',
      onTheseDays: 'On these days',
      noDayMeansEveryDay: 'Pick no day to run it every day.',
      onlyIf: 'Only if',
      conditionsMatch: 'How the conditions combine',
      allOfThese: 'All of these',
      anyOfThese: 'Any of these',
      noColumnToCheck: 'This board has no status, people or date column to check yet.',
      runsOnEveryMatchingRow:
        'Runs on every row the trigger matches. Add a condition to narrow it down.',
      or: 'Or',
      addCondition: 'Add condition',
      plus: 'plus',
      by: 'by',
      into: 'Into',
      sameTypeColumn: 'A column of the same type',
      specificPeople: 'Specific people',
      whoeverMadeTheChange: 'Whoever made the change',
      whoeverCreatedTheRow: 'Whoever created the row',
      enterAValueToCompare:
        'Enter the value to compare with. A number comparison needs a plain number, and Between needs a lower and an upper one.',
      eachConditionNeedsAValue:
        'Each condition needs a column the board still has and at least one value.',
      aiFillTriggersItself:
        "An AI action can't write the column that sets this rule off: every answer would run it again. Pick another column.",
      noOneMakesTimedChanges:
        'A rule that runs on a schedule or a date has no one making the change. Pick who to assign instead.',
      earlier: 'Earlier',
      later: 'Later',
      add: 'Add',
      subtract: 'Subtract',
      inZone: 'In {{zone}}',
      specificPeopleToEmail: 'Specific people',
      peopleOnTheRow: 'People on the row',
      peopleOnTheRowCount_one: '{{count}} from the row',
      peopleOnTheRowCount_other: '{{count}} from the row',
      peopleInColumn: 'People in {{column}}',
      emailNote: 'Add a note to the email (optional)',
      emailsGoTo:
        'Only people who can open this board and row get the email, one per rule every couple of minutes.',
      commentText: 'What the comment says',
      mentionPeople: 'Mention people',
      commentSignedByRule:
        'The comment is posted as this automation, on behalf of whoever created it.',
      webhookUrl: 'Webhook URL',
      webhookUrlPlaceholder: 'https://example.com/hooks/…',
      slackWebhookUrl: 'Slack incoming webhook URL',
      slackWebhookUrlPlaceholder: 'https://hooks.slack.com/services/…',
      savedUrl: 'Saved: {{preview}}. Type a new URL to replace it.',
      webhookSignedWith:
        "Requests are signed like board webhooks, in X-Webhook-Signature, with this rule's secret: {{secret}}",
      webhookSignedOnceSaved:
        "Requests are signed like board webhooks. The rule's signing secret appears here once it is saved.",
      slackLine: "A line above the row's values (optional)",
      slackCarriesValues: "Posts the row's title and filled columns to the webhook's channel.",
      newRowTitle: 'Title of the new row',
      targetBoard: 'Board',
      pickABoard: 'Pick a board',
      boardInWorkspace: '{{name}} ({{workspace}})',
      thisBoard: 'This board',
      boardUnavailable: 'Board unavailable',
      loadingBoards: 'Loading boards…',
      boardsFailed: "Boards couldn't be loaded",
      rowCellsCarryOver:
        'Each cell carries over into the same column on the other board, or else one of the same name and type; the rest stay behind.',
      rowCellsAllCarryOver: 'The copy keeps every cell of the row.',
      archivedRowsLeave:
        'An archived row leaves the board and its counts, and no rule runs on it again.',
    },
    assetsCustomCell: {
      openTheProjectSReview: "Open the project's Review & Approvals — {{label}}",
    },
    automationsPanel: {
      blankRule: 'Blank rule',
      fromRecipe: 'From a recipe',
      moreWaysToCreate: 'More ways to create an automation',
      moreActions: 'More actions',
      moreActionsNamed: 'More actions: {{summary}}',
      edit: 'Edit',
      delete: 'Delete',
      activateAutomation: 'Activate automation',
      automations: 'Automations',
      automationsFailedToLoad: 'Automations failed to load',
      back: 'Back',
      byAuthor: 'by {{author}}',
      createARuleToReact:
        'Create a rule to react to changes on this board — for example, when Status becomes Done, move the item to the Done group.',
      createAutomation: 'Create automation',
      editAutomation: 'Edit automation',
      editAutomationNamed: 'Edit automation: {{summary}}',
      lastNever: 'last never',
      lastRun: 'last {{timestamp}}',
      metaSeparator: ' · ',
      newAutomation: 'New automation',
      noAutomationsYet: 'No automations yet',
      noRunsYet: 'No runs yet',
      pauseAutomation: 'Pause automation',
      runActionsAutomaticallyWhenThis: 'Run actions automatically when this board changes.',
      runsCount_one: '{{count}} run',
      runsCount_other: '{{count}} runs',
      saveChanges: 'Save changes',
      somethingWentWrongLoadingThis: "Something went wrong loading this board's rules.",
      tryAgain: 'Try again',
      runNow: 'Run now',
      runOnMatchingRows: 'Run on matching rows',
      countingRows: 'Counting the rows this rule would change…',
      willChangeRows_one: 'This will change {{count}} row.',
      willChangeRows_other: 'This will change {{count}} rows.',
      noRowsToChange:
        'No row needs changing right now. Every row this rule matches already holds what it would write.',
      runOnRows_one: 'Run on {{count}} row',
      runOnRows_other: 'Run on {{count}} rows',
      countFailed: "The rows couldn't be counted. Try again.",
      runQueued_one: '{{count}} row is being updated.',
      runQueued_other: '{{count}} rows are being updated.',
      runPartlyQueued_one:
        '{{queued}} of {{count}} row is being updated. Run it again for the rest.',
      runPartlyQueued_other:
        '{{queued}} of {{count}} rows are being updated. Run it again for the rest.',
      runFailed: "The rule couldn't run. Try again.",
      copyName: '{{name}} (copy)',
      deleteAutomation: 'Delete automation',
      deleteCannotBeUndone: "This rule stops running on this board. Deleting it can't be undone.",
      deleteFailed: "The automation couldn't be deleted. Try again.",
      saveFailed: "The automation couldn't be saved. Try again.",
      duplicate: 'Duplicate',
      name: 'Name',
      namePlaceholder: "Optional. The rule's summary is shown when empty",
      orderDecidesConflicts:
        'Rules apply from top to bottom. When two write the same column, the lower one wins. Drag to reorder.',
      reorder: 'Reorder',
      reorderAutomationNamed: 'Reorder automation: {{summary}}',
      reorderFailed: "The new order couldn't be saved. Try again.",
      brokenReference: {
        triggerColumn:
          'Not running: the column this rule watches was deleted. Edit the rule to fix it.',
        triggerOption:
          'Not running: the option this rule waits for was removed from its column. Edit the rule to fix it.',
        conditionColumn:
          'Not running: a condition names a column this board no longer has. Edit the rule to fix it.',
        actionColumn:
          'An action writes or copies a column this board no longer has, and is skipped. Edit the rule to fix it.',
        actionOption: 'An action sets a status option that was removed. Edit the rule to fix it.',
        group: 'An action moves rows to a group that was deleted. Edit the rule to fix it.',
      },
      thisRule: 'This rule',
      loopArrow: ' → ',
      loopWarning:
        'Loop: “{{rule}}” sets off {{others}}, which sets it off again. The board stops the chain after five steps, so the result depends on where it stops.',
      selfLoopWarning:
        'Loop: “{{rule}}” writes the column it watches, so it sets itself off again. The board stops it after five steps.',
      conflictDraftWins:
        '“{{other}}” also writes {{column}} on the same change. “{{rule}}” wins, because it is lower in the list.',
      conflictOtherWins:
        '“{{other}}” also writes {{column}} on the same change and wins, because it is lower in the list. Reorder the rules to change that.',
      boardLimitReached:
        'This board already has {{limit}} automations, the most it can hold. Delete one to add another.',
      organizationLimitReached:
        'This organization already has {{limit}} automations, the most it can hold. Delete one to add another.',
      onlyOwnerOrAdminManages: "Only the board's owner or an admin can change these automations.",
    },
    avatarStack: {
      moreCount: '{{count}} more',
      unknownUser: 'Unknown user',
    },
    boardViewTabs: {
      cardsByStatusColumn: 'Cards by status column.',
      chartsAndRollUpMetrics: 'Charts and roll-up metrics.',
      dashboard: 'Dashboard',
      dragToReorder: 'Drag to reorder',
      itemsOnADateAxis: 'Items on a date axis.',
      kanban: 'Kanban',
      layout: 'Layout',
      layoutPrefix: 'Layout:',
      opensByDefault: '{{label}} · opens by default',
      reorderLayout: 'Reorder {{label}}',
      rowsGroupedBySection: 'Rows grouped by section.',
      showLayout: 'Show {{label}}',
      table: 'Table',
      timeline: 'Timeline',
    },
    approvalCustomCell: {
      approve: 'Approve',
      approved: 'Approved',
      approvedOn: 'Approved {{date}}',
      awaitingReview: 'Awaiting review',
      clear: 'Clear',
      noReviewer: 'No reviewer',
      pending: 'Pending',
      reject: 'Reject',
      rejected: 'Rejected',
      rejectedOn: 'Rejected {{date}}',
      requestApproval: 'Request approval',
      reviewer: 'Reviewer',
    },
    buttonConfigModal: {
      buttonLabel: 'Button label',
      cancel: 'Cancel',
      configureButton: 'Configure button',
      eGApproveSendNotify: 'e.g. Approve, Send, Notify',
      save: 'Save',
    },
    buttonCustomCell: {
      run: 'Run',
    },
    cellContextMenu: {
      clear: 'Clear',
      copy: 'Copy',
      paste: 'Paste',
    },
    checkboxCustomCell: {
      checked: 'Checked',
      unchecked: 'Unchecked',
    },
    commentsBadge: {
      commentCount_one: '{{count}} comment',
      commentCount_other: '{{count}} comments',
      noComments: 'No comments',
      overflowCount: '{{count}}+',
      unreadSuffix: ', unread',
    },
    customTrackerBoard: {
      columnCopy: '{{label}} copy',
      configureGroups: 'Configure groups',
      custom: 'Custom',
      dueDate: 'Due date',
      newGroup: 'New Group',
      newGroupNumbered: 'New Group {{number}}',
      none: 'None',
      notes: 'Notes',
      owner: 'Owner',
      status: 'Status',
      untitledGroup: 'Untitled Group',
      yourFirstItem: 'Your First Item',
    },
    boardCapNotice: {
      showingTheFirstItems:
        'Showing the first {{cap}} items — refine filters or search to narrow the list.',
    },
    dashboard: {
      columnProgress: '{{column}} progress',
      itemsByColumn: 'Items by {{column}}',
      itemsCreatedOverTime: 'Items created over time',
      noValue: 'No value',
      totalColumn: 'Total {{column}}',
      totalItems: 'Total items',
    },
    dashboardView: {
      addedAStarterDashboard: 'Added a starter dashboard',
      addWidget: 'Add widget',
      assembleYourDashboard: 'Assemble your dashboard',
      dashboardGenerated: 'Dashboard generated',
      designing: 'Designing…',
      generateWithAi: 'Generate with AI',
      keepCurrent: 'Keep current',
      regenerate: 'Regenerate',
      regenerateThisDashboard: 'Regenerate this dashboard?',
      regenerateWithAi: 'Regenerate with AI',
      replaceAllCurrentWidgets_one:
        'AI will design a new dashboard from your columns and <strong>replace all {{count}} current widget</strong>. This can\u2019t be undone.',
      replaceAllCurrentWidgets_other:
        'AI will design a new dashboard from your columns and <strong>replace all {{count}} current widgets</strong>. This can\u2019t be undone.',
      replaceTheCurrentWidgetsWith: 'Replace the current widgets with an AI-designed dashboard',
      visualizeThisTrackerWithKpis:
        'Visualize this tracker with KPIs, charts and progress bars — or let AI design one from your columns.',
    },
    dashboardWidgets: {
      acrossItems_one: 'across {{count}} item',
      acrossItems_other: 'across {{count}} items',
      items: 'items',
      noDataYet: 'No data yet.',
    },
    dateCustomCell: {
      clear: 'Clear',
    },
    dateRangeCustomCell: {
      clear: 'Clear',
      setDates: 'Set dates',
    },
    filesCustomCell: {
      addFile: 'Add file',
      attachFiles: 'Attach files',
      displayNameOptional: 'Display name (optional)',
      fileUrl: 'File URL',
      filesAttached_one: '{{count}} file attached',
      filesAttached_other: '{{count}} files attached',
      removeFile: 'Remove {{name}}',
    },
    formulaConfigModal: {
      availableColumns: 'Available columns',
      cancel: 'Cancel',
      configureFormula: 'Configure formula',
      eGBudgetHours: 'e.g. {Budget} / {Hours}',
      expression: 'Expression',
      referenceOtherColumnsBy:
        'Reference other columns by name in braces and combine them with + - * / and parentheses.',
      save: 'Save',
    },
    grouping: {
      noOwner: 'No owner',
      ungrouped: 'Ungrouped',
    },
    kanbanView: {
      addAStatusColumnIn:
        'Add a Status column in the Table view to organize items on a Kanban board.',
      addItem: 'Add item',
      cardsCannotBeMovedBetween:
        'Cards cannot be moved between lanes here: {{column}} is set where the record itself lives.',
      cardsReadOnlyForYou:
        'You can view these records but not change their {{column}}, so cards stay in their lanes.',
      itemTitle: 'Item title',
      noItemsMatchTheFilters: 'No items match the filters',
      noStatus: 'No status',
      noStatusColumnYet: 'No Status column yet',
      nothingHereYet: 'Nothing here yet',
    },
    linkCustomCell: {
      openLink: 'Open link',
    },
    peopleCustomCell: {
      assignPeople: 'Assign people',
      clearAll: 'Clear all',
      noPeopleFound: 'No people found.',
      searchPeople: 'Search people',
      searchPeopleLabel: 'Search people',
    },
    progressCustomCell: {
      percent: '{{value}}%',
      percentComplete: '{{value}}% complete',
    },
    readOnlyCell: {
      preview: 'Preview',
    },
    recordFields: {
      approval: 'Approval',
      approvalStep: 'Approval step',
      assets: 'Assets',
      created: 'Created',
      deadline: 'Deadline',
      fileSize: 'Size',
      fileType: 'File type',
      lastActivity: 'Last activity',
      market: 'Market',
      name: 'Name',
      openComments: 'Open comments',
      owner: 'Owner',
      pendingAssets: 'Pending assets',
      preview: 'Preview',
      project: 'Project',
      purpose: 'Purpose',
      reviewStatus: 'Review status',
      startDate: 'Start date',
      status: 'Status',
      tags: 'Tags',
      title: 'Title',
      type: 'Type',
      updated: 'Updated',
      uploaded: 'Uploaded',
      uploadedBy: 'Uploaded by',
      version: 'Version',
      workspace: 'Workspace',
    },
    recordStatusOptions: {
      approvalCompleted: 'Approved',
      approvalInProgress: 'In review',
      approvalNotStarted: 'Not started',
      reviewApproved: 'Approved',
      reviewNotApplicable: 'Not applicable',
      reviewRejected: 'Rejected',
      reviewToReview: 'To review',
    },
    recordPreviewModal: {
      couldNotLoad: 'Could not load this file',
      couldNotLoadDescription: 'The file did not come back. Open the asset to see it in full.',
      noPreview: 'Nothing to show here',
      noPreviewDescription:
        'This file type has no preview on the board. Open the asset to see it in full.',
      openAsset: 'Open asset',
      tryAgain: 'Try again',
      typeAndSize: '{{type}} · {{size}}',
    },
    recordTrackerBoard: {
      couldNotLoad: 'Could not load this board',
      couldNotLoadDescription:
        'The rows did not come back. Nothing here is out of date, just absent.',
      couldNotRefresh: 'Could not refresh this board',
      loadingMore: 'Loading more…',
      noMatches: 'No records match',
      noMatchesDescription: 'Clear a filter or change the search to widen the board.',
      nothingHereYet: 'Nothing here yet',
      nothingHereYetDescription: 'Records appear on this board as soon as they exist.',
      showingWhatLoadedLast: 'These rows are the last set that loaded, so they may be behind.',
      tryAgain: 'Try again',
      untitled: 'Untitled',
    },
    sortChoices: {
      columnSoonest: '{{name}}, soonest',
      itemAZ: 'Item A → Z',
      nameAZ: 'Name (A–Z)',
      nameZA: 'Name (Z–A)',
      newestFirst: 'Newest first',
      oldestFirst: 'Oldest first',
    },
    statusConfigModal: {
      addOption: 'Add option',
      option: 'option',
      reorderOption: 'Reorder {{label}}',
      setColourTo: 'Set colour to {{color}}',
      cancel: 'Cancel',
      configureStatusOptions: 'Configure status options',
      customColor: 'Custom color…',
      deleteOption: 'Delete option',
      optionLabel: 'Option label',
      pickACustomColour: 'Pick a custom colour',
      pickColour: 'Pick colour',
      save: 'Save',
    },
    statusCustomCell: {
      clear: 'Clear',
      noOptionsYetOpenConfigure: 'No options yet — open Configure status from the column menu.',
    },
    tagsCustomCell: {
      addTag: 'Add tag',
      addTags: 'Add tags',
      newTag: 'New tag',
      noTagsYet: 'No tags yet',
      removeTag: 'Remove {{tag}}',
    },
    teamCustomCell: {
      setTeam: 'Set team',
      teamName: 'Team name',
    },
    textCustomCell: {
      typeHere: 'Type here…',
    },
    timelineCustomCell: {
      addPhase: 'Add phase',
      endDate: 'End date',
      newPhase: 'New phase',
      phaseName: 'Phase name',
      phaseProgress: '<phase>{{label}}</phase> · {{position}} of {{total}}',
      removePhase: 'Remove {{label}}',
      setPhases: 'Set phases',
      startDate: 'Start date',
    },
    timelineView: {
      addADateOrDate:
        'Add a Date or Date range column in the Table view to plot items on a timeline.',
      noDateOrDateRange: 'No Date or Date range column yet',
      noItemsHaveAYet: 'No items have a {{columnLabel}} yet — set dates in the Table view.',
      today: 'Today',
    },
    trackerCommentsPanel: {
      closeCommentsPanel: 'Close comments panel',
      commentLinkCopied: 'Comment link copied',
      comments: 'Comments',
      couldNotCopyTheLink: 'Could not copy the link',
      couldNotDeleteThe: 'Could not delete the comment',
      couldNotLoadComments: 'Could not load the comments',
      couldNotLoadCommentsDescription:
        'The thread is still there. Try again, or reopen the panel in a moment.',
      couldNotPostComment: 'Could not post your comment',
      couldNotPostCommentDescription: 'What you wrote is still in the box. Try again.',
      couldNotRefreshComments: 'Could not refresh the comments',
      couldNotReopenThe: 'Could not reopen the comment',
      couldNotResolveThe: 'Could not resolve the comment',
      everyCommentIsResolved: 'Every comment is resolved',
      hideResolvedComments: 'Hide resolved comments',
      justNow: 'Just now',
      newest: 'Newest',
      noCommentsYet: 'No comments yet',
      oldest: 'Oldest',
      reopenComment: 'Reopen comment',
      replyCount_one: '{{count}} reply',
      replyCount_other: '{{count}} replies',
      resolveComment: 'Resolve comment',
      resolvedComments: 'Resolved comments',
      rowComments: 'Row comments',
      showNewestFirst: 'Show newest first',
      showOldestFirst: 'Show oldest first',
      showResolvedComments: 'Show resolved comments',
      showResolvedCommentsTo: 'Turn on Resolved comments to read them.',
      showingWhatLoadedLast: 'This thread is the last version that loaded, so it may be behind.',
      startTheThreadItStays: 'Start the thread. It stays with this row for anyone who opens it.',
      threadUnavailable: "This row's comments aren't available on this board.",
      tryAgain: 'Try again',
      unknownUser: 'Unknown user',
      writeAComment: 'Write a comment…',
      automationAuthor: 'Automation ({{name}})',
      automationAuthorUnnamed: 'Automation',
      yesterday: 'Yesterday',
    },
    trackersBoardTable: {
      addGroup: 'Add group',
      noBriefsFound: 'No briefs found.',
    },
    trackersBriefRow: {
      clickToRename: 'Click to rename',
      delete: 'Delete',
      deleteItem: 'Delete {{title}}',
      dragItem: 'Drag {{title}}',
      dragToReorder: 'Drag to reorder',
      late: 'Late',
      moreActions: 'More actions',
      moreActionsFor: 'More actions for {{title}}',
      openItem: 'Open {{title}}',
      previewItem: 'Preview {{title}}',
      rename: 'Rename',
    },
    trackersEmptyState: {
      briefsWillAppearHereOnce: "Briefs will appear here once they're created in any project.",
      noBriefsYet: 'No briefs yet',
    },
    trackersFilterPanel: {
      advancedFilters: 'Advanced filters',
      allColumns: 'All columns',
      and: 'And',
      clearAll: 'Clear all',
      later: 'Later',
      newFilter: 'New filter',
      noConditions: 'No conditions yet — add one to narrow the tracker.',
      openFilters: 'Filter items',
      openFiltersWithCount_one: 'Filter items, {{count}} filter active',
      openFiltersWithCount_other: 'Filter items, {{count}} filters active',
      operatorIs: 'is',
      operatorIsNot: 'is not',
      overdue: 'Overdue',
      quickFilters: 'Quick filters',
      recentFilters: 'Recent filters',
      removeFilter: 'Remove filter',
      removeValue: 'Remove {{label}}',
      ruleColumn: 'Filter column, {{label}} selected',
      ruleOperator: 'Operator, {{label}} selected',
      ruleValues: 'Values for {{label}}',
      selectValues: 'Select values',
      showingAll_one: 'Showing all of {{count}} item',
      showingAll_other: 'Showing all of {{count}} items',
      showingSome_one: 'Showing {{visible}} of {{count}} item',
      showingSome_other: 'Showing {{visible}} of {{count}} items',
      switchToAdvanced: 'Switch to advanced filters',
      switchToQuick: 'Switch to quick filters',
      thisMonth: 'This month',
      unavailableColumn: 'Unavailable column',
      unavailableColumnHint: 'This column was deleted. Pick another one or remove the filter.',
      valueCount: '/ {{count}}',
      valueWithCount_one: '{{label}}, {{count}} item',
      valueWithCount_other: '{{label}}, {{count}} items',
      where: 'Where',
    },
    trackersProjectGroup: {
      addColumn: 'Add column',
      addColumnToTheRight: 'Add column to the right',
      addItem: 'Add item',
      columnMenu: '{{label}} column menu',
      configureButton: 'Configure button',
      configureFormula: 'Configure formula',
      configureStatus: 'Configure status',
      delete: 'Delete',
      deleteGroup: 'Delete group {{title}}',
      renameGroup: 'Rename group {{title}}',
      doubleClickToRename: 'Double-click to rename',
      noItemsMatchTheCurrent: 'No items match the current filters',
      noItemsYet: 'No items yet',
      dragGroup: 'Drag group {{title}}',
      duplicate: 'Duplicate',
      item: 'Item',
      itemCount_one: '{{count}} item',
      itemCount_other: '{{count}} items',
      rename: 'Rename',
      scrollToLoadTheseItems: 'Keep scrolling to load these items',
      sortBy: 'Sort by {{label}}',
      untitled: 'Untitled',
      untitledProject: 'Untitled Project',
    },
    trackersToolbar: {
      addOrRemoveFilters: 'Add or remove filters',
      addOrRemoveFiltersWithCount_one: 'Add or remove filters, {{count}} active',
      addOrRemoveFiltersWithCount_other: 'Add or remove filters, {{count}} active',
      filter: 'Filter',
      filterByColumn: 'Filter by column',
      groupBy: 'Group by',
      groupItems: 'Group items',
      noFilterableColumns: 'No filterable columns',
      search: 'Search',
      searchLabel: 'Search items',
      sortItems: 'Sort items',
    },
    workspaceScope: {
      all: 'All my workspaces',
      locked: 'Workspace: {{name}}',
      lockedPrefix: 'Workspace:',
      noMatches: 'No workspaces match',
      notSaved: 'Could not change which workspaces this board shows',
      rowsFrom: 'Show rows from',
      search: 'Search workspaces',
      searchPlaceholder: 'Find a workspace',
      trigger: 'Workspaces: {{value}}',
      triggerPrefix: 'Workspaces:',
      unnamedWorkspace: 'Unnamed workspace',
      valueAll: 'All ({{total}})',
      valueSome: '{{count}} of {{total}}',
    },
    useRecordBoard: {
      changeUndone: 'The cell is back to its saved value.',
      notSaved: 'Could not save {{field}}',
      notSavedChange: 'Could not save your change',
      noValue: 'No value',
      refusedAssetNameTaken: 'Another file in this folder already has that name.',
      refusedInvalidFieldValue: 'That value is not accepted for this field.',
      refusedItemArchived: 'This row is archived. Restore it to edit it.',
      refusedItemNotFound: 'This row was removed, or you no longer have access to it.',
      refusedRecordEditForbidden: 'You can view this record but not edit it.',
      refusedRowNotFound: 'This record was removed, or you no longer have access to it.',
      refusedStartDateAfterDeadline: 'The start date has to be on or before the deadline.',
      refusedTrackerViewOnly: 'You have view-only access to this board.',
      saved: '{{field}} updated',
      savedOnRecord: '{{field}} updated on {{record}}',
    },
    useTrackersBoard: {
      allBriefs: 'All briefs',
      approval: 'Approval',
      briefType: 'Brief type',
      button: 'Button',
      checkbox: 'Checkbox',
      columnCopy: '{{label}} (Copy)',
      columnCopyNumbered: '{{label}} (Copy {{number}})',
      custom: 'Custom',
      date: 'Date',
      dateRange: 'Date range',
      done: 'Done',
      dueDate: 'Due date',
      files: 'Files',
      formula: 'Formula',
      link: 'Link',
      newGroup: 'New Group',
      newGroupNumbered: 'New Group {{number}}',
      noProject: 'No project',
      notes: 'Notes',
      noType: 'No type',
      number: 'Number',
      owner: 'Owner',
      people: 'People',
      progress: 'Progress',
      project: 'Project',
      projectAssets: 'Project assets',
      status: 'Status',
      stuck: 'Stuck',
      tags: 'Tags',
      team: 'Team',
      text: 'Text',
      timeline: 'Timeline',
      untitledProject: 'Untitled project',
      workingOnIt: 'Working on it',
    },
    viewOnly: {
      boardNotice: 'You can view this tracker, but not change it.',
      commentsNotice: 'You can read the comments on this tracker, but not add them.',
      noDashboardDescription: 'Someone who can edit this tracker can add one.',
      noDashboardYet: 'No dashboard yet',
      noDateColumnDescription:
        'Someone who can edit this tracker can add a Date or Date range column.',
      noStatusColumnDescription: 'Someone who can edit this tracker can add a Status column.',
    },
    widgetSettingsModal: {
      addWidget: 'Add widget',
      allItems: 'All items',
      aStatusColumnAsOne: 'A status column as one stacked bar.',
      aTextBlockToLabel: 'A text block to label sections.',
      average: 'Average',
      averageColumn: 'Average {{column}}',
      barChart: 'Bar chart',
      calculation: 'Calculation',
      cancel: 'Cancel',
      columnProgress: '{{column}} progress',
      compareCountsPerValue: 'Compare counts per value.',
      count: 'Count',
      createdDate: 'Created date',
      donut: 'Donut',
      editWidget: 'Edit widget',
      eGDeliveryHealth: 'e.g. Delivery health',
      groupBy: 'Group by',
      heading: 'Heading',
      itemsByColumn: 'Items by {{column}}',
      itemsByNoColumn: 'Items by column',
      itemsOverTime: 'Items over time',
      itemsOverTimeByWeek: 'Items over time, by week or month.',
      month: 'Month',
      number: 'Number',
      oneBigNumberACount: 'One big number — a count, sum or average.',
      overTime: 'Over time',
      pickAColumn: 'Pick a column',
      preview: 'Preview',
      progress: 'Progress',
      saveChanges: 'Save changes',
      sectionHeading: 'Section heading',
      shareOfItemsAcrossA: 'Share of items across a column.',
      source: 'Source',
      sum: 'Sum',
      text: 'Text',
      title: 'Title',
      totalColumn: 'Total {{column}}',
      totalItems: 'Total items',
      week: 'Week',
      widget: 'Widget',
    },
    widgetShell: {
      delete: 'Delete',
      doubleClickToRename: 'Double-click to rename',
      dragWidget: 'Drag {{title}}',
      editWidget: 'Edit widget',
      rename: 'Rename',
      resizeWidget: 'Resize {{title}}',
      widgetMenu: '{{title}} widget menu',
    },
    automationRuns: {
      aDeletedAutomation: 'A deleted automation',
      aDeletedColumn: 'A deleted column',
      aDeletedGroup: 'a deleted group',
      changed: 'changed',
      checked: 'Checked',
      cleared: 'Cleared',
      empty: 'No automation has run here in the last 30 days.',
      failedToLoad: "The history couldn't be loaded.",
      group: 'Group',
      history: 'History',
      loadMore: 'Load more',
      outcomes: {
        applied: 'Changed',
        no_change: 'No change',
        failed: 'Failed',
        dropped_depth: 'Stopped in a loop',
        skipped_no_access: 'Skipped',
        skipped_no_access_target: 'No access to target',
      },
      people_one: '{{count}} person',
      people_other: '{{count}} people',
      retention: 'History is kept for 30 days.',
      rowActivity: 'Automation activity',
      setOffBy: 'set off by {{name}}',
      effects: {
        notifyDone_one: 'Emailed {{count}} person',
        notifyDone_other: 'Emailed {{count}} people',
        notifySkipped: 'Email skipped: nobody it names can open the row',
        notifyFailed: 'Email failed',
        commentDone: 'Commented',
        commentSkipped: 'Comment skipped',
        commentFailed: 'Comment failed',
        webhookDone: 'Webhook queued',
        webhookSkipped: 'Webhook skipped',
        webhookFailed: "Webhook couldn't be queued",
        slackDone: 'Slack post queued',
        slackSkipped: 'Slack post skipped',
        slackFailed: "Slack post couldn't be queued",
        rowCreated: 'Created a row',
        rowCopied: 'Copied the row',
        rowMoved: 'Moved the row',
        rowArchived: 'Archived the row',
        noAccessToSourceBoard: 'Skipped: the author can no longer act on this board',
        noAccessToTargetBoard: "Skipped: the author can't write to the target board",
        rowActionSkipped: 'Row action skipped',
        rowActionFailed: 'Row action failed',
        heldForAi: 'Waiting for the AI actions to finish',
        peopleLeftOut_one: "{{count}} left out: not in this organization, or can't open the row",
        peopleLeftOut_other: "{{count}} left out: not in this organization, or can't open the row",
      },
      unchecked: 'Unchecked',
    },
    automationPreview: {
      change: '{{column}}: {{before}} → {{after}}',
      failed: "The rows couldn't be checked against this rule.",
      pickARow: 'Pick a row',
      rowAlreadyHolds: 'This row already holds everything the rule writes.',
      rowFailsConditions:
        "This row doesn't pass the rule's conditions, so the rule would leave it alone.",
      rowInTriggerState: 'It is already in the state the trigger waits for.',
      rowNotInTriggerState: "It isn't in the state the trigger waits for yet.",
      rowWouldGet: 'If the rule fired on this row: {{changes}}.',
      searchRows: 'Search rows',
      testOnARow: 'Test on a row',
      untitledRow: 'Untitled row',
      wouldChangeNone: 'No row would change if this ran today.',
      wouldChangeToday_one: 'This would change {{count}} row if it ran today.',
      wouldChangeToday_other: 'This would change {{count}} rows if it ran today.',
    },
    automationRecipes: {
      browse: 'Recipes',
      intro:
        'Start from a rule that works on boards like this one. It opens in the builder, so you can change anything before saving.',
      recipesTitle: 'Recipes',
      needs: {
        statusColumn: 'Needs a status column.',
        dateColumn: 'Needs a date column.',
        checkboxColumn: 'Needs a checkbox column.',
        peopleColumn: 'Needs a people column.',
        groups: 'Needs at least one group.',
      },
      recipes: {
        stampDateWhenDone: {
          title: "Date it when it's done",
          description: 'When a status reaches its last option, set a date column to today.',
        },
        assignCreator: {
          title: 'Assign whoever adds it',
          description: 'When a row is created, assign the person who created it.',
        },
        weeklyCheckboxReset: {
          title: 'Reset a checkbox every week',
          description: 'Every Monday at 09:00, uncheck a checkbox column on every row.',
        },
        checkWhenDateArrives: {
          title: 'Flag it on its date',
          description: 'When a date arrives, check a checkbox column.',
        },
        moveDoneToGroup: {
          title: 'Move finished rows to a group',
          description: 'When a status reaches its last option, move the row to the last group.',
        },
        stampDateOnApproval: {
          title: 'Date the approval',
          description: 'When an asset is approved, set a date column to today.',
        },
        assignOnChangesRequested: {
          title: 'Assign who asked for changes',
          description: 'When someone requests changes on an asset, assign them.',
        },
      },
    },
    automationAi: {
      untrustedNote:
        'Values from the row are sent to the model, so anyone who can edit the row can influence the result.',
      budget: {
        open: 'AI budget',
        title: 'AI budget',
        intro:
          "What the organization's automations may spend on AI each month, across every workspace. Once this month's spend reaches it, AI actions fail, and say so in the run history, until the budget is raised or the month turns.",
        capLabel: 'Monthly budget ({{currency}})',
        adminOnly: 'Only an organization admin can change the budget.',
        spent: '{{spent}} of {{cap}} spent this month.',
        resets: 'It starts again on {{date}} (UTC).',
        defaultNote: 'No budget has been set yet, so the default applies.',
        save: 'Save budget',
        saved: 'AI budget saved',
        saveFailed: "The AI budget couldn't be saved.",
        loadFailed: "The AI budget couldn't be loaded.",
        invalid: 'Enter an amount of 0 or more.',
        tooHigh: 'Enter an amount of {{max}} or less.',
        reachedWarning:
          "This month's AI budget is spent, so this rule's AI actions will fail until an admin raises it.",
      },
      fill: {
        option: 'Fill with AI',
        summary: 'fill {{column}} with AI: "{{instruction}}"',
        modeLabel: 'AI mode',
        modes: {
          classify: 'Classify',
          extract: 'Extract',
          summarize: 'Summarize',
        },
        columnLabel: 'Column to fill',
        instructionLabel: 'Instruction for the AI',
        instructionPlaceholder: 'For example: rate how urgent this request is',
        hint: "The AI reads this row and writes only this cell. Written cells are marked, and count against the organization's AI budget.",
      },
      runs: {
        fillQueued: 'Asked AI to fill a cell',
        fillDone: 'Filled by AI ({{model}}, prompt {{promptVersion}})',
        fillFailed: 'AI fill failed',
        agentQueued: 'Asked an agent',
        agentDone: 'An agent replied in the comments ({{model}})',
        agentFailed: 'The agent run failed',
        skipped: 'AI action skipped',
      },
      reasons: {
        budget_reached: "AI action failed: this month's AI budget is spent",
        model_not_allowed: "AI action failed: the organization doesn't allow the AI model",
        model_access_unknown:
          "AI action failed: couldn't confirm the workspace may use the AI model",
        no_edit_access: "AI action skipped: the rule's author can't edit this board",
        no_answer: "AI action skipped: the row didn't say enough to answer",
        invalid_output: "AI action failed: the answer didn't fit the column",
        ai_call_failed: "AI action failed: the AI couldn't be reached",
        internal_error: 'AI action failed: something went wrong on our side',
        rule_changed: 'AI action skipped: the rule changed before it ran',
        row_gone: 'AI action skipped: the row no longer exists',
        agent_not_allowed: "AI action failed: the rule's author can't run this agent",
        agent_not_supported:
          "AI action failed: this agent uses tools that automations can't run yet",
        agent_not_found: 'AI action failed: the agent no longer exists',
        agent_run_pending: 'AI action failed: the agent was still working when the retries ran out',
        agent_input_changed:
          'AI action failed: the rule changed while the agent was still answering, so nothing was posted',
        after_ai_write: 'AI action skipped: another AI action made this change',
        ai_workspace_missing:
          "AI action failed: the rule doesn't say which workspace's AI to use. Edit the rule and save it again",
        organization_missing: "AI action failed: this board doesn't belong to an organization yet",
      },
      cell: {
        writtenBy: 'Written by AI ({{model}}, prompt {{promptVersion}})',
      },
      describe: {
        open: 'Describe a rule',
        title: 'Describe a rule',
        intro:
          "Say what should happen in a sentence. AI proposes a rule using this board's columns; nothing is saved until you open it in the builder and save it there.",
        label: 'What should happen?',
        placeholder: 'For example: when the status becomes Done, set Finished on to today',
        propose: 'Propose a rule',
        proposing: 'Proposing…',
        review: 'Proposed rule',
        openInBuilder: 'Open in builder',
        notUnderstood:
          "That doesn't describe a rule this board can run. Try saying when it should happen and what it should do.",
        malformed: "AI's answer couldn't be read as a rule. Try again, or build the rule yourself.",
        invalid:
          "AI couldn't turn that into a rule this board can run. Try rewording it, or build the rule yourself.",
        budget:
          "This month's AI budget is spent, so rules can't be proposed until an admin raises it.",
        failed: "The rule couldn't be proposed. Try again.",
      },
      agent: {
        option: 'Run an agent',
        summary: 'ask an agent and comment its answer: "{{input}}"',
        agentLabel: 'Agent',
        currentAgent: 'Current agent',
        agentInWorkspace: '{{agent}} ({{workspace}})',
        workspaceRequired: 'Choose the agent again, so the rule knows which workspace runs it.',
        notAllowed:
          "You can't run that agent, so the rule wasn't saved. Choose one you can run, or keep the current agent.",
        inputLabel: 'What to ask the agent',
        inputPlaceholder: 'For example: review {title} and flag anything missing from {Brief}',
        hint: "Write {title} or {Column name} to put this row's values in. The answer is posted as a comment by the rule. Only agents without tools or knowledge bases can run from a rule, so only those are listed.",
      },
      suggestions: {
        title: 'Suggested rules',
        intro:
          'People on this board keep making these edits by hand. Review one to open it in the builder; nothing is created until you save it.',
        seenOn_one: 'Seen on {{count}} row in the last two weeks',
        seenOn_other: 'Seen on {{count}} rows in the last two weeks',
        review: 'Review',
        reviewNamed: 'Review: {{summary}}',
        dismiss: 'Dismiss',
        dismissNamed: 'Dismiss: {{summary}}',
        failed: "The suggestion couldn't be updated. Try again.",
      },
    },
    automationErrors: {
      aiBudgetForbidden: 'Only an organization admin can change the AI budget.',
      aiModelNotAllowed:
        "This workspace's organization doesn't allow the AI model these actions run on.",
      aiFillSelfTrigger:
        "An AI action can't fill the column that sets off its own rule. Choose another column.",
      editForbidden: "Only the board's owner or an admin can change its automations.",
      limitReached:
        'This board or organization already holds as many automations as it can. Delete one to add another.',
      peopleOutsideWorkspace: "A rule can only email or mention people in its author's workspaces.",
      rowLoop: "A rule that runs on a new row can't add or copy a row on its own board.",
      authorCannotEdit:
        "Saving would make you this rule's author, and you can't edit the rows it acts on, so its actions would be skipped. The rule wasn't saved.",
      createCycle:
        'This rule would add rows that set off rules adding rows back, in a loop. Change which board it adds rows to.',
      trackerViewOnly: 'You have view-only access to this board.',
      targetBoardNotFound:
        'The board this rule adds, copies or moves rows to no longer exists. Choose another board.',
      paused: 'This automation was switched off. Switch it on before running it.',
      duplicateFailed: "The automation couldn't be duplicated. Try again.",
    },
  },
  trackerTemplate: {
    builtinTemplates: {
      assetsBoard: 'Assets Board',
      assignee: 'Assignee',
      budget: 'Budget',
      bugTracker: 'Bug Tracker',
      campaignTracker: 'Campaign Tracker',
      channel: 'Channel',
      contentCalendar: 'Content Calendar',
      coordinateEveryDeliverableInA:
        'Coordinate every deliverable in a marketing campaign, with a rollup dashboard.',
      done: 'Done',
      dueDate: 'Due date',
      everyDeliverableAcrossYour:
        'Every deliverable across your projects, grouped by where it stands in approval.',
      everyProjectYouCanOpen:
        'Every project you can open, grouped by status with owner, deadline and workload.',
      high: 'High',
      inProgress: 'In progress',
      inReview: 'In review',
      low: 'Low',
      medium: 'Medium',
      notStarted: 'Not started',
      owner: 'Owner',
      planScheduleAndTrackContent:
        'Plan, schedule, and track content across channels from draft to published.',
      priority: 'Priority',
      projectsBoard: 'Projects Board',
      publishDate: 'Publish date',
      reported: 'Reported',
      runASprintAsA: 'Run a sprint as a kanban board with story points and assignees.',
      sprintBoard: 'Sprint Board',
      status: 'Status',
      storyPoints: 'Story points',
      triageAndResolveIssuesWith: 'Triage and resolve issues with status, priority, and assignee.',
    },
    types: {
      everyoneInThisWorkspace: 'Everyone in this workspace',
      everyoneInYourOrganization: 'Everyone in your organization',
      onlyYouCanSeeAnd: 'Only you can see and reuse it',
      organization: 'Organization',
      private: 'Private',
      workspace: 'Workspace',
    },
  },
} as const;
